﻿/**
 * sv-element decorator
 * @namespace angular-sortable-view
 */

(function() {
	'use strict';

	/** decorate the sv-element directive */
	angular.module('angular-sortable-view').config(config);

	/** injection */
	config.$inject = ['$provide'];
	svElementDecorator.$inject = ['$delegate', '$parse'];

	/** config implementation */
	function config($provide) {
		/** create the sv-element decorator */
		$provide.decorator('svElementDirective', svElementDecorator);
	}

	/** svElementDecorator implementation */
	function svElementDecorator($delegate, $parse) {
		/** get the directive */
		var directive = $delegate[0];

		/** set compile function */
		directive.compile = compileFunc;

		/** compileFunc implementation */
		function compileFunc() {
			return newLinkFunc;
		}

		/** create new link function */
		function newLinkFunc($scope, $element, $attrs, $controllers) {
			var sortableElement = {
				element: $element,
				getPart: $controllers[0].getPart,
				getIndex: function(){
					return $scope.$index;
				}
			};
			$controllers[1].addToSortableElements(sortableElement);
			$scope.$on('$destroy', function(){
				$controllers[1].removeFromSortableElements(sortableElement);
			});

			var handle = $element;

			/******************************************************************************************
			 * PATCHED AREA OF CODE
			 * https://github.com/RobertjanTuit/angular-sortable-view/commit/2d9438e70ce6df6373dec0cf5c4ff341eaffbf3a
			******************************************************************************************/

			var startTimer;
			var clearEvent = function() {
				clearTimeout(startTimer);
			};

			var opts = $parse($attrs.svElement)($scope);
			opts = angular.extend({}, {
				delay: 0
			}, opts);

			/** check for disabled flag */
			if (opts.disabled !== true) {
				var event = onMousedown;
				if (opts.delay) {
					event = function (e) {
						html.on('mouseup touchend', clearEvent);
						startTimer = setTimeout(function () { onMousedown(e); }, opts.delay);
					};
				}

				handle.on('mousedown touchstart', event);

				$scope.$watch('$ctrl.handle', function(customHandle){
					if(customHandle){
						clearEvent();
						handle.off('mousedown touchstart', event);
						handle = customHandle;
						handle.on('mousedown touchstart', event);
					}
				});
			}

			/******************************************************************************************/

			var helper;
			$scope.$watch('$ctrl.helper', function(customHelper){
				if(customHelper){
					helper = customHelper;
				}
			});

			var placeholder;
			$scope.$watch('$ctrl.placeholder', function(customPlaceholder){
				if(customPlaceholder){
					placeholder = customPlaceholder;
				}
			});

			var html = angular.element(document.documentElement);

			var moveExecuted;

			function onMousedown(e){
				touchFix(e);

				if($controllers[1].sortingInProgress()) return;
				if(e.button !== 0 && e.type === 'mousedown') return;

				// START - for Behavior Module : Student's List page - Bug #20772
				var isForBehaviorList = false;

				if (e.toElement) {
                    if (e.toElement.ownerDocument) {
                        if (e.toElement.ownerDocument.URL.indexOf('behavior') > 0 && e.toElement.ownerDocument.URL.indexOf('list') > 0) {
                            var words = _.words(e.toElement.ownerDocument.URL);

                            var numbers = _.remove(words, function (n) {
                                return !isNaN(n);
                            });

                            numbers = _.drop(numbers, 2);   // drop unncessary course info

                            numbers = _.chunk(numbers, 3);  // split array to compare dates

                            isForBehaviorList = _.difference(numbers[0], numbers[1]).length === 0;
                        }
                    }
                }
				// END - for Behavior Module : Student's List page

				moveExecuted = false;
				var opts = $parse($attrs.svElement)($scope);
				opts = angular.extend({}, {
					tolerance: 'pointer',
					revert: 200,
					containment: 'html'
				}, opts);
				if(opts.containment){
					var containmentRect = closestElement.call($element, opts.containment)[0].getBoundingClientRect();
				}

				var target = $element;
				var clientRect = $element[0].getBoundingClientRect();
				var clone;

				if(!helper) helper = $controllers[0].helper;
				if(!placeholder) placeholder = $controllers[0].placeholder;
				if(helper){
					clone = helper.clone();
					clone.removeClass('ng-hide');
					clone.css({
					    'left': clientRect.left + document.body.scrollLeft + 'px',
					    'top': clientRect.top + document.body.scrollTop + 'px'
					});
					target.addClass('sv-visibility-hidden');
				}
				else{
					clone = target.clone();

					var width = isForBehaviorList ? (clone.context.clientWidth - clone.context.lastElementChild.clientWidth) : clientRect.width;

					clone.addClass('sv-helper').css({
					    'left': clientRect.left + document.body.scrollLeft + 'px',
					    'top': clientRect.top + document.body.scrollTop + 'px',
					    'width': width + 'px'
					});
				}

				clone[0].reposition = function(coords){
					var targetLeft = coords.x;
					var targetTop = coords.y;
					var helperRect = clone[0].getBoundingClientRect();

					var body = document.body;

					if(containmentRect){
						if(targetTop < containmentRect.top + body.scrollTop) // top boundary
							targetTop = containmentRect.top + body.scrollTop;
						if(targetTop + helperRect.height > containmentRect.top + body.scrollTop + containmentRect.height) // bottom boundary
							targetTop = containmentRect.top + body.scrollTop + containmentRect.height - helperRect.height;
						if(targetLeft < containmentRect.left + body.scrollLeft) // left boundary
							targetLeft = containmentRect.left + body.scrollLeft;
						if(targetLeft + helperRect.width > containmentRect.left + body.scrollLeft + containmentRect.width) // right boundary
							targetLeft = containmentRect.left + body.scrollLeft + containmentRect.width - helperRect.width;
					}
					this.style.left = targetLeft - body.scrollLeft + 'px';
					this.style.top = targetTop - body.scrollTop + 'px';
				};

                var pointerOffset = {
                    x: (e.clientX - clientRect.left)/clientRect.width,
                    y: (e.clientY - clientRect.top)/clientRect.height
                };
				html.addClass('sv-sorting-in-progress');
				html.on('mousemove touchmove', onMousemove).on('mouseup touchend touchcancel', function mouseup(){
					html.off('mousemove touchmove', onMousemove);
					html.off('mouseup touchend', mouseup);
					html.removeClass('sv-sorting-in-progress');
					if(moveExecuted){
						$controllers[0].$drop($scope.$index, opts);
					}
					$element.removeClass('sv-visibility-hidden');
				});

				// onMousemove(e);
				function onMousemove(e){
					touchFix(e);
					if(!moveExecuted){
						$element.parent().prepend(clone);
						moveExecuted = true;
					}
					$controllers[1].$moveUpdate(opts, {
						x: e.clientX,
						y: e.clientY,
						offset: pointerOffset
					}, clone, $element, placeholder, $controllers[0].getPart(), $scope.$index);
				}
			}
		}

		/** add methods from original sv-sort module that only exist in its context */
		function touchFix(e){
			if(!('clientX' in e) && !('clientY' in e)) {
				var touches = e.touches || e.originalEvent.touches;
				if(touches && touches.length) {
					e.clientX = touches[0].clientX;
					e.clientY = touches[0].clientY;
				}
				e.preventDefault();
			}
		}
		var closestElement = angular.element.prototype.closest || function (selector){
			var el = this[0].parentNode;
			while(el !== document.documentElement && !el[matchingFunction](selector))
				el = el.parentNode;
			if(el[matchingFunction](selector))
				return angular.element(el);
			else
				return angular.element();
		};

		/** return the delegate */
		return $delegate;
	}
})();